import {getActionFromState, getStateFromPath, createNavigationContainerRef, StackActions} from '@react-navigation/native';
import {isArray, isEmpty} from 'lodash';
import qs from 'qs';
import {Keyboard} from 'react-native';
import config from '../config';
import {trackAnalyticsScreenView} from './analytics';
import WizzeeLog from './wizzeeLog';

export const navigationRef = createNavigationContainerRef();

let _navigator = navigationRef;

const setTopLevelNavigator = (navigatorRef: any) => {
  _navigator = navigatorRef;
};

export const getNavigator = () =>
  new Promise(resolve => {
    if (_navigator && _navigator.isReady()) {
      resolve(_navigator);
      return;
    } else {
      WizzeeLog.warn('>>> navigate() - navigarionRef is not ready yet.');
    }

    const interval = setInterval(() => {
      if (_navigator && _navigator.isReady()) {
        resolve(_navigator);
        clearInterval(interval);
      } else {
        WizzeeLog.warn('>>> navigate() - navigarionRef is not ready yet.');
      }
    }, 50);
  });

  export function goBack() {
    if (_navigator && _navigator.isReady()) {
      _navigator.goBack();
    } else {
      WizzeeLog.warn('>>> navigate() - navigarionRef is not ready yet.');
    }
  }

export function navigate(name, params) {
  if (_navigator && _navigator.isReady()) {
    _navigator.navigate(name, params);
  } else {
    WizzeeLog.warn('>>> navigate() - navigarionRef is not ready yet.');
  }
}

export function push(...args) {
  if (_navigator && _navigator.isReady()) {
    _navigator.dispatch(StackActions.push(...args));
  } else {
    WizzeeLog.warn('>>> push() - navigarionRef is not ready yet.');
  }
}

const dispatch = (...args: any): Promise<void> =>
  getNavigator().then(navigator => navigator.dispatch(...args));

export const getActivationInitialRouteName = () => {
  if (config.displayRequiredToActivatePage) {
    return 'requiredToActivateSim';
  } else {
    if (config.displaySelfieCheck) {
      WizzeeLog.error('Should be implemented');
      return '';
    } else {
      return 'simCardManual';
    }
  }
};

export const resetToPath = async (path: string, params: Object = {}) => {
  await getNavigator();
  const pathSuffix = !isEmpty(params) ? `?${qs.stringify(params)}` : '';
  const state = getStateFromPath(path + pathSuffix);
  const action = getActionFromState(state);
  if (action) {
    await dispatch(action);
  }
};

export const getNavigatorState = () => _navigator.getRootState();

export const routeFromNavigationStateSelector = (state: any) => {
  if (!state) return null;
  const currentRootRoute = state.routes[state.index];
  if (isArray(currentRootRoute.routes)) {
    return routeFromNavigationStateSelector(currentRootRoute);
  }

  if (currentRootRoute.state) {
    if (isArray(currentRootRoute.state.routes)) {
      return routeFromNavigationStateSelector(currentRootRoute.state);
    }
  }

  return currentRootRoute;
};

export const getCurrentRoute = () => {
  return routeFromNavigationStateSelector(getNavigatorState());
};

const getRootRoute = (): Object => {
  const state = getNavigatorState();
  return state.routes[state.index];
};

export const getRootRouteParams = (): Object => {
  const currentRootRoute = getRootRoute();
  return currentRootRoute.params || {};
};

export const isOrderingReplacementSim = (): boolean => {
  const state = getNavigatorState();
  const firstSignUpRoute = state.routes[1];
  return (
    firstSignUpRoute &&
    firstSignUpRoute.params &&
    firstSignUpRoute.params.isOrderingReplacementSim
  );
};

export const onNavigationStateChange = async (state: any) => {
  const route = routeFromNavigationStateSelector(state);
  const routeName = route?.name;
  await trackAnalyticsScreenView(routeName);
  Keyboard && Keyboard.dismiss();
};

export default {
  dispatch,
  setTopLevelNavigator,
};
